// extracted by mini-css-extract-plugin
module.exports = {"hidden":"src-components-common-hidden-___hidden__hidden___2Omy4"};